<template>
  <UkrTreasuresEditingUser
          :UT="UT"
          :shippingMethods="shippingMethods"
          @save="save({edit: true, id: UT.getId()})"
  />
</template>

<script>
  import UkrTreasuresEditingUser from "./UkrTreasuresEditingUser/UkrTreasuresEditingUser";
  import {UkrTreasures} from "../../models/UkrTreasures";
  import {ukrTreasuresMixin} from "../../../../../mixins/ukrTreasuresMixins/ukrTreasuresMixin";
  import {TNT_DELIVERY_SERVICE} from "../../../../../staticData/staticVariables";

  export default {
    name: "UkrTreasuresEditing",

    components: {
      UkrTreasuresEditingUser,
    },

    mixins: [ukrTreasuresMixin],

    data() {
      return {
        UT: new UkrTreasures(),
        shippingMethods: []
      }
    },

    mounted() {
      this.UT.setId(this.$route.params.id)

      // initialize first product


      const query = new this.Query();
      let url = '?';
      let myQuery = query
        .for('posts')

      myQuery.where('DeliveryServiceUseForListings', true)

      url = url + myQuery.limit(100000).page(1).url().split('?')[1]

      this.$store.dispatch('fetchShippingCompany', url).then(response => {
        this.shippingMethods = this.getRespPaginateData(response).filter(item => {
          return item.id !== TNT_DELIVERY_SERVICE.id
        })

        this.$store.dispatch('getUkrTreasuresEdit', this.UT.getId()).then(() => {

          // set EXPRESS with all models
          this.UT.setItem(this.$store.getters.getUkrTreasuresItem, this.shippingMethods)

          // set EXPRESS image & pdf files
          this.setFiles()

        })
      }).catch(error => this.createErrorLog(error))


    },

    methods: {

      setFiles() {
        let files = this.$store.getters.getUkrTreasuresItem.big_images_file
        if (files) {
          files.map(item => {
            this.$store.dispatch('getFileFromServer', item.id)
              .then((response) => {
                this.UT.setUkrTreasuresDownloadFiles(response)
              }).catch(error => this.createErrorLog(error))
          })
        }
      },

    }

  }
</script>

<style scoped>

</style>
